import React, { Component } from 'react';
import './../css/Actividad.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import { faHome, faEdit, faTrash } from "@fortawesome/free-solid-svg-icons";
import BootstrapTable from 'react-bootstrap-table-next';
import { ReactComponent as EditarIcon } from './../../img//svg/Editar.svg';
import { ReactComponent as EliminarIcon } from './../../img//svg/Eliminar.svg';
import enviar from './../../img/svg/Enviar(blanco).svg';

export class Solicitud_actividad extends Component {
    static displayName = Solicitud_actividad.name;

    constructor(props) {
        super(props);
        this.state = {
            actividades: [], busqueda: "", actividad: {
                idactividad: 0, actividad: "", tipoactividad: 0, descripcion: "", idtipoactividad: "", numhoras: 0,
                anio: "", termino: "", termino1: "", termino2: "", termino3: "", periodicidad: "", totalhoras: 0, estadocheck: "", escarga: ""
            }, termino: "", observacion: "", pao1: "", pao2: "", pae: "", accion: "",loading: false, loading2: false
        };
        this.onInputChange = this.onInputChange.bind(this);  
        this.agregarSolicitud = this.agregarSolicitud.bind(this);
        this.onChangeValue = this.onChangeValue.bind(this);
    }

    componentDidMount() {
        this.setState({
            termino: this.get_radios(this.props.pao1, this.props.pao2, this.props.pae, this.props.anio),
            observacion: this.props.observacion
        })
        //console.log(this.state.termino)
    }

    //funcion para click en update delete
    handleClick = (text) => {
        //console.log('accion:', text);
        this.setState({
            accion: text,
        });
    }
    onChangeValue(event) {
        this.setState({
            accion: event.target.value,
        });
    }

    onInputChange(event) {
        //console.log(JSON.stringify(event.target.name))
        var control = event.target.name;
        if (control === "review") {
            //var value = this.state.observacion;
            var value = event.target.value;
            this.setState({
                observacion: value
            });
        }
        else if (control === "inlineRadioOptions") {
                var value = event.target.value;

                this.setState({
                    pao1: value == 1 ? "1" : "",
                    pao2: value == 2 ? "2" : "",
                    pa3: value == 3 ? "3" : ""
                });
        } else if (control === "inlineRadioAction") {
                    var value = event.target.value;
                    this.setState({
                        accion: value, 
                    });
        }
    }
    get_radios(termino1, termino2, termino3, anio) {
        var respu;
        if (termino2 === "2" && termino1 === "1" && termino3 === "0") {
            return (
                'PAE-' + anio + '\n  PAO-' + anio + '-1\n PAO-' + anio + '-2'
            )
        }
        else if (termino1 === "1") {
            if (termino1 === "1" && termino3 === "0") {
                return (
                    'PAO-' + anio + '-1 \nPAE-' + anio
                );
            } else if (termino2 === "2" && termino1 === "1") {
                return (
                    'PAO-' + anio + '-1 \nPAO-' + anio + '-2'
                );

            } else {
                return (
                    'PAO-' + anio + '-1'
                );
            }
        } else if (termino2 === "2") {
            if (termino2 === "2" && termino1 === "1") {
                return (
                    'PAO-' + anio + '-1\n PAO-' + anio + '-2'
                );

            } else if (termino2 === "2" && termino3 === "0") {
                return (
                    'PAO-' + anio + '-2\n PAE-' + anio
                );
            }
            return (
                'PAO-'+anio+'-2'
            );
        } else if (termino3 === "0") {
            if (termino3 === "0" && termino1 === "1") {
                return (
                    'PAE-' + anio + '\n PAO-' + anio + '-1'
                );

            } else if (termino3 === "0" && termino2 === "2") {
                return (
                    'PAE-' + anio + '\n PAO-' + anio + '-2'
                );
            }
            return (
                'PAE-' + anio
            );
        }
    }

    agregarSolicitud(event) {
        event.preventDefault();
        let terminoeval = this.get_radios(this.props.termino1, this.props.termino2, this.props.termino3, this.props.anio);
        this.setState({
            termino: terminoeval
        })
        //console.log('AGREEGANDO SOLICITUD[EXPAND]: ' + this.props.idactividad + '|' + this.props.descripcion + '|' + this.props.totalhoras + '|' + this.props.anio + '|' + terminoeval+'|'+ this.props.tipoactividad+'|'+ this.state.observacion+'|'+ this.props.termino1+'|'+ this.props.termino2+'|'+ this.props.termino3+'|'+ this.state.accion)
        this.props.updatestate(this.props.idactividad, this.props.descripcion, this.props.totalhoras, this.props.anio, terminoeval, this.props.tipoactividad, this.state.observacion, this.props.termino1, this.props.termino2, this.props.termino3, this.state.accion)
    }


    render() {
        let radios = this.get_radios(this.props.termino1, this.props.termino2, this.props.termino3, this.props.anio);
        
       // console.log(this.props)
        return (
            <div>
                <div className="box2 sb9"><table className='table table-striped' aria-labelledby="tabelLabel">
                    <thead>
                        <tr className='tr-tablexpand-header'>
                            <th className='tr-descr-header'></th>
                            <th className='tr-obser-header'></th>
                            <th className='tr-perio-header'></th>
                            <th className='tr-accio-header'></th>
                        </tr>
                    </thead>

                    <tbody>
                        <tr>
                            <td className='td-descr-header'>Actividad</td>
                            <td className='td-obser-header'>Observacion</td>
                            <td className='td-perio-header'>Periodo</td>
                            <td className='td-accio-header'>Acciones</td>
                        </tr>
                        <tr>
                            <td>{this.props.descripcion}</td>
                            <td><textarea id="review" name="review" className='area_width' value={this.state.observacion} onChange={this.onInputChange}>{this.state.observacion}</textarea></td>
                            <td>
                                {radios} 
                            </td>
                            <td>

                                <div onChange={this.onChangeValue}>

                                    <div className="form-check-despl">
                                        <FontAwesomeIcon icon={faEdit} className="icon-cursor" name="accion" onChange={this.onChangeValue} onClick={() => this.handleClick("Modificar Carga")} style={this.state.accion === "Modificar Carga" ? { color: '#ffdb00' } : { color: '#58A7E0' }} size="2x" />
                                        &nbsp;&nbsp;|&nbsp;&nbsp;
                                        <FontAwesomeIcon icon={faTrash} className="icon-cursor" name="accion" onChange={this.onChangeValue} onClick={() => this.handleClick("Eliminar Carga")} style={this.state.accion === "Eliminar Carga" ? { color: '#ffdb00' } : { color: '#58A7E0' }} size="2x" />
                                    </div>

                                </div>


                                <div>
                                    <button type="button" className="btn btn-sm btn-info btn-agregar" onClick={this.agregarSolicitud}>    {/* funcion para guardar la solicitud y enviar a la unificada*/}
                                        <img width="24px" height="24px" src={enviar} />Agregar Solicitud</button>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>





                </div>

            </div>
        );
    }


}
